import { ScrollView, View, Text, StyleSheet, Image } from "react-native";
import { Colors, Spacing, Typography } from "../styles";
import DataSources from "../components/profile/DataSources";
import Stats from "../components/profile/Stats";
import Card from "../components/profile/Card";
import { useSelector } from "react-redux";
import { selectUser } from "../redux/mainSlice";

const Profile = () => {
  const user = useSelector(selectUser);

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      <View style={styles.inner}>
        {/* Name */}
        <Text style={[Typography.title, styles.title]}>{user.name}</Text>

        <DataSources style={{ marginBottom: 10 }} />

        <Stats style={{ marginBottom: 40 }} />

        <Card
          title="Linked Devices"
          rows={[
            {
              title: "MacBook Pro",
              subtitle: "Last active today at 19:20",
              icon: "laptop",
              chevron: "hidden",
            },
            {
              title: "iPhone",
              subtitle: "Last active today at 22:03",
              icon: "mobile-phone",
              chevron: "hidden",
            },
            {
              title: "Manage devices",
              icon: "laptop",
            },
          ]}
          style={{ marginBottom: 20 }}
        />
        <Card
          title="Account"
          rows={[
            {
              title: "Manage account",
              icon: "user-o",
            },
            {
              title: "Privacy and safety",
              icon: "shield",
            },
            {
              title: "Invite friends",
              icon: "user-o",
            },
            {
              title: "Alias management",
              icon: "user-o",
              chevron: "pro",
            },
          ]}
          style={{ marginBottom: 20 }}
        />
        <Card
          title="Legal"
          rows={[
            {
              title: "Terms of service",
              icon: "user-o",
            },
            {
              title: "Privacy policy",
              icon: "shield",
            },
          ]}
        />

        <View style={[styles.row, styles.appVersion]}>
          <Text style={Typography.paragraph}>App version</Text>
          <Text style={Typography.paragraph}>1.0.0</Text>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.plum900,
    flex: 1,
  },
  inner: {
    padding: Spacing.page,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: { marginBottom: 30 },
  appVersion: { opacity: 0.5, marginTop: 20, marginHorizontal: Spacing.page },
});

export default Profile;
